<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      class="triangle"
      d="M13 10L7.75 13.4641L7.75 6.5359L13 10Z"
      stroke="currentColor"
      fill="currentColor"
      stroke-width="1.5"
      stroke-miterlimit="40"
      stroke-linecap="square"
    />
  </svg>
</template>
